import { render, staticRenderFns } from "./QuestionnaireFormQuestionText.vue?vue&type=template&id=5a4d11ba"
import script from "./QuestionnaireFormQuestionText.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormQuestionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports